import { supabase } from '../lib/supabase'

export class AssessmentService {
  static async saveAssessment(assessmentData) {
    try {
      console.log('💾 Saving assessment to Supabase...', {
        name: assessmentData.userInfo.name,
        email: assessmentData.userInfo.email,
        score: assessmentData.totalScore
      });

      const { data, error } = await supabase
        .from('assessments_bf2025')
        .insert([
          {
            user_name: assessmentData.userInfo.name,
            user_email: assessmentData.userInfo.email,
            total_score: assessmentData.totalScore,
            max_score: assessmentData.maxScore,
            percentage: assessmentData.percentage,
            section_scores: assessmentData.sectionScores,
            answers: assessmentData.answers,
            completed_at: assessmentData.completedAt
          }
        ])
        .select()

      if (error) {
        console.error('❌ Error saving assessment:', error)
        return { success: false, error: error.message }
      }

      console.log('✅ Assessment saved successfully:', data[0]?.id)
      return { success: true, data: data[0] }
    } catch (error) {
      console.error('❌ Error in saveAssessment:', error)
      return { success: false, error: error.message }
    }
  }

  static async getUserAssessments(email) {
    try {
      console.log('🔍 Fetching assessments for:', email);

      const { data, error } = await supabase
        .from('assessments_bf2025')
        .select('*')
        .eq('user_email', email)
        .order('completed_at', { ascending: false })

      if (error) {
        console.error('❌ Error fetching user assessments:', error)
        return { success: false, error: error.message }
      }

      console.log(`✅ Found ${data?.length || 0} assessments for user`);
      return { success: true, data }
    } catch (error) {
      console.error('❌ Error in getUserAssessments:', error)
      return { success: false, error: error.message }
    }
  }

  static async getAssessmentAnalytics() {
    try {
      console.log('📊 Fetching assessment analytics...');

      const { data, error } = await supabase
        .from('assessment_analytics')
        .select('*')
        .limit(30) // Last 30 days

      if (error) {
        console.error('❌ Error fetching analytics:', error)
        return { success: false, error: error.message }
      }

      console.log(`✅ Retrieved analytics for ${data?.length || 0} days`);
      return { success: true, data: data || [] }
    } catch (error) {
      console.error('❌ Error in getAssessmentAnalytics:', error)
      return { success: false, error: error.message }
    }
  }

  static async getRecentAssessments(limit = 10) {
    try {
      console.log('🕒 Fetching recent assessments...');

      const { data, error } = await supabase
        .from('assessments_bf2025')
        .select('user_name, user_email, percentage, completed_at')
        .order('completed_at', { ascending: false })
        .limit(limit)

      if (error) {
        console.error('❌ Error fetching recent assessments:', error)
        return { success: false, error: error.message }
      }

      console.log(`✅ Retrieved ${data?.length || 0} recent assessments`);
      return { success: true, data: data || [] }
    } catch (error) {
      console.error('❌ Error in getRecentAssessments:', error)
      return { success: false, error: error.message }
    }
  }

  static async checkDatabaseConnection() {
    try {
      console.log('🔌 Checking Supabase connection...');

      const { data, error, count } = await supabase
        .from('assessments_bf2025')
        .select('*', { count: 'exact', head: true })

      if (error) {
        console.error('❌ Database connection error:', error)
        return { success: false, error: error.message }
      }

      console.log('✅ Supabase connected successfully - Total assessments:', count)
      return { success: true, count: count }
    } catch (error) {
      console.error('❌ Error checking database connection:', error)
      return { success: false, error: error.message }
    }
  }

  // Test method to verify data insertion
  static async testDataInsertion() {
    try {
      console.log('🧪 Testing data insertion...');

      const testData = {
        userInfo: {
          name: 'Test User',
          email: 'test@example.com'
        },
        totalScore: 25,
        maxScore: 54,
        percentage: 46,
        sectionScores: {
          foundation: { score: 10, maxScore: 24, percentage: 42 },
          clarity: { score: 5, maxScore: 9, percentage: 56 },
          action: { score: 4, maxScore: 9, percentage: 44 },
          support: { score: 3, maxScore: 6, percentage: 50 },
          optimization: { score: 3, maxScore: 6, percentage: 50 }
        },
        answers: {
          foundation_1: 1,
          foundation_2: 2,
          // ... simplified for test
        },
        completedAt: new Date().toISOString()
      };

      const result = await this.saveAssessment(testData);
      
      if (result.success) {
        console.log('✅ Test data insertion successful:', result.data?.id);
      } else {
        console.error('❌ Test data insertion failed:', result.error);
      }

      return result;
    } catch (error) {
      console.error('❌ Error in test data insertion:', error);
      return { success: false, error: error.message };
    }
  }
}